/**
 * Cijferbalk over de klantenbasis (ontwerp 31): Klanten totaal, Actief in
 * 90 dagen met procent, Nieuw deze maand (tot nu toe) en Klantwaarde
 * gemiddeld. `null` is "nog niet bijgehouden", nooit een 0.
 */
import { useQuery } from "@tanstack/react-query";
import type { ReactNode } from "react";

import { v6Api } from "../api";
import { euro } from "../Rechts/opmaak";
import { v6Sleutels } from "../sleutels";
import { NogNiet } from "./kaart/NogNiet";
import { getal } from "./opmaak";

function Tegel({ label, waarde, onder }: { label: string; waarde: ReactNode; onder?: ReactNode }) {
  return (
    <div className="kl-tegel">
      <span className="l">{label}</span>
      <b className="w num">{waarde}</b>
      {onder ? <span className="o">{onder}</span> : null}
    </div>
  );
}

export function Cijferbalk() {
  const cijfers = useQuery({
    queryKey: v6Sleutels.klantenCijfers,
    queryFn: () => v6Api.klantenCijfers(),
    staleTime: 5 * 60_000,
  });
  const c = cijfers.data;
  const leeg = cijfers.isError ? <NogNiet soort="onbekend" /> : "";
  const procent = c && c.totaal > 0 ? Math.round((c.actief_90d / c.totaal) * 100) : null;
  return (
    <div className="kl-cijferbalk" role="group" aria-label="Klanten in cijfers" aria-busy={cijfers.isLoading || undefined}>
      <Tegel label="Klanten totaal" waarde={c ? getal(c.totaal) : leeg} />
      <Tegel
        label="Actief in 90 dagen"
        waarde={c ? getal(c.actief_90d) : leeg}
        onder={procent !== null ? `${procent}%` : null}
      />
      <Tegel
        label="Nieuw deze maand"
        waarde={c ? getal(c.nieuw_deze_maand) : leeg}
        onder={c ? "tot nu toe" : null}
      />
      <Tegel
        label="Klantwaarde gemiddeld"
        waarde={
          c ? (
            c.klantwaarde_gem_cents === null ? (
              <NogNiet />
            ) : (
              euro(c.klantwaarde_gem_cents)
            )
          ) : (
            leeg
          )
        }
      />
    </div>
  );
}
